import { Uuid } from '../dto/common.js';
import { z } from '../zod.js';
/**
 * Events of one AI run (baseline section 7 "Run lifecycle"), streamed from `ai_run_event`.
 * Draft: contracts package 3.0 freezes it. Every event is `{runId, seq, type, data}`.
 * No budget or ceiling field exists (PLAN section 5 #2); `usage` records tokens and cost only.
 */
const base = { runId: Uuid, seq: z.number().int().nonnegative() };
export const AI_RUN_EVENT_TYPES = [
    'thinking_summary',
    'delta',
    'citation',
    'tool',
    'proposal',
    'usage',
    'section',
    'done',
    'error',
];
export const AI_STOP_REASONS = [
    'end_turn',
    'refusal',
    'max_tokens',
    'model_context_window_exceeded',
    'cancelled',
];
export const AiRunEventV1 = z.discriminatedUnion('type', [
    z.strictObject({
        ...base,
        type: z.literal('thinking_summary'),
        data: z.strictObject({ text: z.string() }),
    }),
    z.strictObject({ ...base, type: z.literal('delta'), data: z.strictObject({ text: z.string() }) }),
    z.strictObject({
        ...base,
        type: z.literal('citation'),
        data: z.strictObject({
            source: z.string().min(1),
            title: z.string().optional(),
            quote: z.string().optional(),
        }),
    }),
    z.strictObject({
        ...base,
        type: z.literal('tool'),
        data: z.strictObject({
            name: z.string().min(1),
            phase: z.enum(['call', 'result']),
            isError: z.boolean().optional(),
        }),
    }),
    z.strictObject({
        ...base,
        type: z.literal('proposal'),
        data: z.strictObject({ proposalId: Uuid, kind: z.string().min(1) }),
    }),
    z.strictObject({
        ...base,
        type: z.literal('usage'),
        data: z.strictObject({
            inputTokens: z.number().int().nonnegative(),
            outputTokens: z.number().int().nonnegative(),
            cacheReadInputTokens: z.number().int().nonnegative(),
            cacheCreationInputTokens: z.number().int().nonnegative(),
            costUsd: z.number().nonnegative().optional(),
        }),
    }),
    z.strictObject({
        ...base,
        type: z.literal('section'),
        data: z.strictObject({
            key: z.string().min(1),
            status: z.enum(['started', 'done', 'failed']),
        }),
    }),
    z.strictObject({
        ...base,
        type: z.literal('done'),
        data: z.strictObject({ stopReason: z.enum(AI_STOP_REASONS) }),
    }),
    z.strictObject({
        ...base,
        type: z.literal('error'),
        data: z.strictObject({ code: z.string().min(1), message: z.string() }),
    }),
]);
//# sourceMappingURL=ai-events.js.map